/**
 * NORVANE Free Watch v11 — 3 units of ANY products except the watch = one gift.
 * The catalog price stays normal; Shopify Buy X Get Y applies the real discount.
 * Crucial: never delete a qualified gift just because its automatic discount
 * has not appeared in the initial AJAX cart response. A pending-discount gift
 * stays visible, with a truthful warning and checkout safeguard in Liquid.
 */
(() => {
  if (window.__norvaneGiftV7) return;
  window.__norvaneGiftV7 = true;

  const HANDLE = 'c-a-s-i-o-luxurious-36mm-watch-water-resistant-transferred-steel';
  const MARK = '_elara_reward';
  const GIFT = 'free_watch';
  const NEEDED = 3;
  const SOURCE = 'norvane-watch-v7';
  const drawer = () => document.querySelector('cart-drawer-component[data-elara-rewards-enabled="true"]');
  const base = () => {
    const root = window.Shopify?.routes?.root || '/';
    return root.endsWith('/') ? root : root + '/';
  };
  const path = resource => base() + resource;
  const productHandle = () => drawer()?.dataset.elaraGiftProductHandle || HANDLE;
  const marked = line => line?.properties?.[MARK] === GIFT;
  const markedLines = cart => (cart.items || []).filter(marked);
  const price = line => Number(line.final_line_price ?? (Number(line.final_price || 0) * Number(line.quantity || 0)));
  const hasPrice = line => price(line) > 0;
  let watchId = Number(drawer()?.dataset.elaraGiftProductId || 0);
  let variantId = Number(drawer()?.dataset.elaraGiftVariantId || 0);
  let lookupCache = {handle:'',at:0};
  let doing = false, again = false, timeout = 0, failAt = 0, failSignature = '';
  let latest = null;
  // While the shopper changes 3 -> 2 units, hide the gift immediately. The
  // underlying cart remains Shopify-owned and must confirm its actual removal.
  const REMOVING_CLASS = 'norvane-gift-removing';
  let awaitingQuantityChange = false;
  let quantityChangeFallback = 0;
  const giftHidden = () => document.documentElement.classList.contains(REMOVING_CLASS);
  function finishOptimisticRemoval() {
    document.documentElement.classList.remove(REMOVING_CLASS);
    awaitingQuantityChange = false;
    clearTimeout(quantityChangeFallback);
    quantityChangeFallback = 0;
  }
  function projectedUnits(excludedRow = null) {
    const d = drawer();
    if (!d) return null;
    const inputs = [...d.querySelectorAll('tr.cart-items__table-row:not([data-elara-reward-gift]) input[data-cart-line]')];
    if (!inputs.length) return null;
    return inputs.reduce((sum, input) => {
      if (excludedRow && input.closest('tr') === excludedRow) return sum;
      return sum + Math.max(0, Number(input.value) || 0);
    }, 0);
  }
  function beginOptimisticRemoval() {
    if (!drawer()) return;
    const hasVisibleGift = !!drawer().querySelector('[data-elara-reward-gift]');
    if (!hasVisibleGift && !giftHidden()) return;
    document.documentElement.classList.add(REMOVING_CLASS);
    // A changed input fires BEFORE Horizon's debounced /cart/change.js request.
    // Do not run our sync on the old 3-item cart while that request is pending.
    awaitingQuantityChange = true;
    clearTimeout(timeout);
    clearTimeout(quantityChangeFallback);
    quantityChangeFallback = setTimeout(() => {
      awaitingQuantityChange = false;
      schedule(20);
    }, 1900);
    showStatus('');
  }
  function resolveOptimisticRemoval(cart) {
    if (!giftHidden()) return;
    if (eligible(cart) >= NEEDED) {
      // Quantity update failed or the customer raised quantity back to 3.
      finishOptimisticRemoval();
    } else if (!markedLines(cart).length) {
      // Server confirms there is no gift. If a stale DOM row survived a morph,
      // remove ONLY that phantom row before revealing the refreshed drawer.
      drawer()?.querySelectorAll('[data-elara-reward-gift]').forEach(row => row.remove());
      finishOptimisticRemoval();
    } else {
      // Still being removed by AJAX. Keep row, pending badge and checkout hidden.
      schedule(550);
    }
  }

  const isWatch = line => marked(line) ||
    (watchId > 0 && Number(line.product_id) === watchId) ||
    (line.handle === productHandle()) ||
    (line.url && String(line.url).split('/products/')[1]?.split(/[/?]/)[0] === productHandle()) ||
    (variantId > 0 && Number(line.variant_id) === variantId);
  const eligible = cart => (cart.items || []).reduce((n,line) => n + (isWatch(line) ? 0 : Math.max(0,Number(line.quantity) || 0)),0);

  const copy = {
    pt: {
      pending:'O relógio entrou no carrinho, mas ainda está sendo cobrado. Confira se o desconto automático de 100% está ativo para 3 unidades elegíveis. Finalização bloqueada até o preço ficar €0,00.',
      failure:'Não foi possível adicionar o relógio de brinde automaticamente. Tente novamente ou entre em contato com a loja.'
    },
    de: {
      pending:'Die Uhr wurde hinzugefügt, aber der 100%-Rabatt wurde noch nicht angewendet. Bitte prüfe die Aktion. Der Checkout bleibt gesperrt, bis der Preis 0 € beträgt.',
      failure:'Die Gratis-Uhr konnte nicht hinzugefügt werden. Bitte versuche es erneut oder kontaktiere den Shop.'
    },
    en: {
      pending:'The watch was added, but its 100% discount has not applied. Please check the promotion. Checkout is disabled until the watch costs €0.00.',
      failure:'The free watch could not be added. Please try again or contact the store.'
    }
  };
  const lang = () => document.documentElement?.lang?.slice(0,2) || 'en';
  const msg = key => (copy[lang()] || copy.en)[key];
  function showStatus(message, reason='') {
    const el = document.querySelector('[data-elara-gift-notice]');
    if (el) {el.textContent = message || '';el.hidden = !message;el.style.display = message ? 'block' : 'none';}
    const editor = document.querySelector('[data-elara-editor-gift-status]');
    if (editor && reason) {editor.textContent = reason;editor.style.display='block';}
    if (reason) console.warn('[NORVANE Free Watch]',reason);
  }
  async function ajax(endpoint, payload) {
    const response = await fetch(path(endpoint), {
      method:payload ? 'POST' : 'GET',
      credentials:'same-origin', cache:'no-store',
      headers:{'Accept':'application/json',...(payload ? {'Content-Type':'application/json'} : {})},
      ...(payload ? {body:JSON.stringify(payload)} : {})
    });
    let data;
    try {data=await response.json();} catch {throw Error(`${endpoint}: resposta não JSON (${response.status})`);}
    if (!response.ok || data?.errors || Number(data?.status) >= 400)
      throw Error(String(data?.description || data?.message || data?.errors || `HTTP ${response.status}`));
    return data;
  }
  const read = () => ajax('cart.js');

  async function resolveVariant() {
    const d=drawer();
    const configured=Number(d?.dataset.elaraGiftVariantId || 0);
    if (Number.isSafeInteger(configured) && configured>0) variantId=configured;
    const setId=Number(d?.dataset.elaraGiftProductId || 0);
    if (Number.isSafeInteger(setId) && setId>0) watchId=setId;
    const handle=productHandle();
    if (variantId>0 && watchId>0) return variantId;
    if (lookupCache.handle===handle && Date.now()-lookupCache.at<12000) return variantId;
    lookupCache={handle,at:Date.now()};
    try {
      const p=await ajax(`products/${encodeURIComponent(handle)}.js`);
      if (p?.id) watchId=Number(p.id);
      const variants=p.variants || [];
      const selected=variants.find(v=>Number(v.id)===variantId && v.available) || variants.find(v=>v.available);
      if (!selected && !variantId) throw Error('Produto indisponível ou sem estoque');
      if (selected) variantId=Number(selected.id);
      if (!Number.isSafeInteger(variantId)||variantId<=0) throw Error('ID inválido da variante');
      if (d) d.dataset.elaraGiftVariantId=String(variantId);
    } catch(error) {
      if (!variantId) throw Error(`Falha ao consultar o relógio: ${error.message}`);
      console.warn('[NORVANE Free Watch] Consulta de produto indisponível; usando ID do tema.',error);
    }
    return variantId;
  }

  async function repaint(cart) {
    // Prefer the full server-rendered sections so the watch image, discount and
    // totals are updated together in Horizon and in Shopify theme previews.
    const ids=[...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')]
      .map(el=>el.dataset.sectionId).filter(Boolean))].slice(0,5);
    let sections={};
    if (ids.length) {
      try {
        const url=new URL(window.location.href);
        url.searchParams.set('sections',ids.join(','));
        const response=await fetch(url.toString(),{credentials:'same-origin',cache:'no-store'});
        if (response.ok) sections=await response.json();
      } catch(e) {console.warn('[NORVANE Free Watch] Atualização da gaveta via seções indisponível:',e);}
    }
    document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{
      resource:cart,sourceId:SOURCE,data:{source:SOURCE,itemCount:Number(cart.item_count || 0),sections}
    }}));
  }
  async function change(line,quantity) {
    return ajax('cart/change.js',{id:line.key,quantity});
  }
  async function reconcile() {
    if (!drawer()) return;
    showStatus('');
    let cart=await read();
    let count=eligible(cart);
    let gifts=markedLines(cart);
    let changed=false;
    let selected=0;

    if (count>=NEEDED) {
      try {selected=await resolveVariant();}
      catch(e) {
        const reason=`Relógio não encontrado: ${e.message}`;
        showStatus(msg('failure'),reason);
        return;
      }
    }

    // Keep one existing promotional watch if qualified; never count it as a purchase.
    let keep=null;
    for (const line of gifts) {
      if (count>=NEEDED && selected && Number(line.variant_id)===selected && !keep) {
        keep=line;
        if (Number(line.quantity)!==1) {await change(line,1);changed=true;}
      } else {await change(line,0);changed=true;}
    }
    if (changed) cart=await read();

    if (count>=NEEDED && selected && !keep) {
      const sig=`${selected}|${count}`;
      if (!(sig===failSignature && Date.now()-failAt<4000)) {
        try {
          await ajax('cart/add.js',{items:[{id:selected,quantity:1,properties:{[MARK]:GIFT}}]});
          changed=true;
          cart=await read();
          keep=markedLines(cart).find(line=>Number(line.variant_id)===selected);
          if (!keep) throw Error('A Shopify não retornou o relógio após cart/add.js');
          failSignature='';
        } catch(e) {
          failSignature=sig;failAt=Date.now();
          showStatus(msg('failure'),`cart/add.js: ${e.message}`);
          if (changed) await repaint(cart);
          return;
        }
      }
    }

    // ALWAYS KEEP THE QUALIFIED WATCH VISIBLE. Earlier versions removed it
    // immediately if Shopify hadn't calculated the automatic discount yet.
    if (count>=NEEDED) {
      const gift=markedLines(cart).find(line=>Number(line.variant_id)===selected);
      if (gift && hasPrice(gift)) {
        showStatus(msg('pending'),`O relógio está no carrinho com final_line_price=${price(gift)} (centavos); configure desconto Shopify Compre 3 Leve 1.`);
      } else if (gift) showStatus('');
    } else {
      showStatus('');
      failSignature='';
    }
    latest={count,gifts:markedLines(cart).length,prices:markedLines(cart).map(price)};
    // Avoid constantly repainting an already-clean 2-item cart.
    const hasGhostRow = count < NEEDED && !!drawer()?.querySelector('[data-elara-reward-gift]');
    if (changed || hasGhostRow) await repaint(cart);
    resolveOptimisticRemoval(cart);
  }
  async function sync() {
    if (awaitingQuantityChange) return;
    if (doing) {again=true;return;}
    doing=true;
    try {await reconcile();}
    catch(e) {showStatus(msg('failure'),`Falha no carrinho: ${e.message}`);}
    finally {doing=false;if(again){again=false;schedule(300);}}
  }
  function schedule(ms=220) {
    if (!drawer()) return;
    clearTimeout(timeout);timeout=setTimeout(sync,ms);
  }
  document.addEventListener('cart:update',event=>{
    if (event.detail?.data?.source===SOURCE || event.detail?.data?.didError) return;
    if (awaitingQuantityChange) {
      awaitingQuantityChange = false;
      clearTimeout(quantityChangeFallback);
      quantityChangeFallback = 0;
      schedule(90);
    } else schedule(350);
  });
  // Fired after stepUp()/stepDown(): the input value reflects the new amount.
  // Capture phase runs before the theme's debounced server-side quantity update.
  document.addEventListener('quantity-selector:update',event=>{
    if (!event.target?.closest?.('cart-drawer-component')) {schedule(650);return;}
    const projected = projectedUnits();
    if (projected !== null && projected < NEEDED) beginOptimisticRemoval();
    else if (giftHidden()) finishOptimisticRemoval();
    if (!awaitingQuantityChange) schedule(650);
  }, true);
  // Removing a full product line uses Horizon's on:click handler rather than a
  // quantity-selector:update event; handle that path before the theme sees it.
  document.addEventListener('click', event => {
    const remove = event.target?.closest?.('cart-drawer-component .cart-items__remove');
    if (!remove) return;
    const row = remove.closest('tr.cart-items__table-row');
    if (row?.hasAttribute('data-elara-reward-gift')) return;
    const projected = projectedUnits(row);
    if (projected !== null && projected < NEEDED) beginOptimisticRemoval();
  }, true);
  // Never allow a checkout click while a previously qualified watch may still
  // be present in Shopify's cart, even though its row is hidden visually.
  document.addEventListener('click', event => {
    if (!giftHidden() || !event.target?.closest?.('cart-drawer-component .cart__checkout-button')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
  document.addEventListener('submit', event => {
    if (!giftHidden() || !event.target?.closest?.('cart-drawer-component')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
  document.addEventListener('shopify:section:load',()=>schedule(150));
  document.addEventListener('click',event=>{
    if (event.target?.closest?.('cart-drawer-component,product-form-component,[data-testid="quick-add"]')) schedule(650);
  });
  document.addEventListener('visibilitychange',()=>{if (!document.hidden) schedule(160);});
  window.addEventListener('pageshow',()=>schedule(160));
  window.addEventListener('focus',()=>schedule(250));
  setInterval(()=>{const d=drawer();if(d?.querySelector?.('dialog[open]')) schedule(150);},2800);
  // Read-only help for troubleshooting the merchant's own storefront.
  window.NorvaneGiftStatus=()=>latest;
  window.NorvaneGiftRetry=()=>{failSignature='';schedule(10);};
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>schedule(200),{once:true});
  else schedule(200);
})();
